import React from 'react'
import { useTranslation } from 'react-i18next';
import { Label } from 'reactstrap';
import InfoModal from '../ahu-estonia/InfoModal';
import { CheckboxDefaultValue, CheckboxOptions } from '../ahu/common/checkboxConfig';
import CheckboxGroupOzonator from './common/CheckboxGroupOzonator';
import MeasurementFieldOzonator from './common/MeasurementFieldOzonator';

const OzonatorHardwareForm = () => {
    const { t } = useTranslation();

    return (
        <form className="ahutest-container" >
            <Label className="ahutest-from--title">{t("Riistvara ja tarkvara ühilduvus")}</Label>
            <div className="flexboxAlignedColumn" style={{ padding: "2%" }}>
                <div className="ahutest-form__label-info-button--grid" >
                    <Label className="grid-item-label" >{t("Osonaator käivitub (saab toite), kui seadmel on toitepinge olemas ja lülitist sisselülitatud.")}</Label>
                    <InfoModal title={t("Juhend")} bodyText={"Ühenda osonaatori külge toitekaabel ja lülita seade tööle"} />
                    <CheckboxGroupOzonator
                        options={CheckboxOptions}
                        defaultValue={CheckboxDefaultValue}
                        measurementKey="start-hardware"
                    />
                </div>
                <MeasurementFieldOzonator propertyName="start-hardware" showValue={false} />

                <div className="ahutest-form__label-info-button--grid" >
                    <Label className="grid-item-label" >{t("Juhtpaneeli (LCD ekraan) ja osonaatori omavaheline ühendus toimib")}</Label>
                    <InfoModal title={t("Juhend")} bodyText={"Ühenda osonaatori järgi juhtpaneel 'LCD' pistikusse"} />
                    <CheckboxGroupOzonator
                        options={CheckboxOptions}
                        defaultValue={CheckboxDefaultValue}
                        measurementKey="display-hardware"
                    />
                </div>
                <MeasurementFieldOzonator propertyName="display-hardware" showValue={false} />

                <div className="ahutest-form__label-info-button--grid" >
                    <Label className="grid-item-label" >{t("Tarkvara uuendamine toimib SD kaardiga.")}</Label>
                    <InfoModal title={t("Juhend")} bodyText={"Pane kontrollerile peale testimise tarkvara SD-kaardiga. Kui tarkvara on peal, eemalda SD-kaart kontrolleri seest"} />
                    <CheckboxGroupOzonator
                        options={CheckboxOptions}
                        defaultValue={CheckboxDefaultValue}
                        measurementKey="sdCard-hardware"
                    />
                </div>
                <MeasurementFieldOzonator propertyName="sdCard-hardware" showValue={false} />

                <div className="ahutest-form__label-info-button--grid" >
                    <Label className="grid-item-label" >{t("M-link ja osonaatori vaheline andmeühendus toimib")}</Label>
                    <InfoModal title={t("Juhend")} bodyText={"Ühenda osonaator M-Linki C pordiga ja oota, et M-Linki C COM tuli hakkaks vilkuma. Vilkumine näitab, et ühendus on olemas"} />
                    <CheckboxGroupOzonator
                        options={CheckboxOptions}
                        defaultValue={CheckboxDefaultValue}
                        measurementKey="mLink-hardware"
                    />
                </div>
                <MeasurementFieldOzonator propertyName="mLink-hardware" showValue={false} />
            </div>
        </form>
    )
}

export default OzonatorHardwareForm